import {
  getNews, addNews, updateNews, deleteNews,
  getReadedNews, getSimilarArticle, addSimilarArticle,
  deleteSimilarArticle, getIndexReport, addIndexReport,
  updateIndexReport, deleteIndexReport, getPriceIndexList,
  addUpdatePriceIndex, deletePriceIndex, pushNews,
  getNewsCommentList, getTipoffCommentList, commentOperation,
  deleteNewsComment, getUserFinalPrice, addMarketPriceData,
  getMarketPriceData, updateMarketPriceData, deleteMarketPriceData,
  updateUserMarketPriceData, updateCompanyInfo, getBackendIndexReport,
  getFuturesMarketData, getSpotMarketData, importFuturesMarketData,
  importSpotMarketData, getNewsViewUser, importPriceDataIndexs, selectBeefPriceDataIndex, deleteBeefPriceDataIndex, updateBeefPriceDataIndex,
  importPriceDataResearchs, getPriceDataResearchs, deletePriceDataResearchs, updatePriceDataResearchs, getBeefNewImportExportDatasList,
  updateBeefNewImportExportDatas, deleteBeefNewImportExportDatas, importBeefNewImportExportDatas, getBeefDataEstPatternList, importBeefDataEstPatterns,
  deleteBeefDataEstPatterns, updateBeefDataEstPatterns
} from '@/api/news'

const news = {
  state: {
    total: 0,
    rows: [],
    row: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    }
  },
  actions: {
    // 获取新闻
    GetNews({ commit }, params) {
      return new Promise((resolve, reject) => {
        getNews(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加新闻
    AddNews({ commit }, params) {
      console.log(params)
      return new Promise((resolve, reject) => {
        addNews(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新新闻
    UpdateNews({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateNews(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除新闻
    DeleteNews({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteNews(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户试读过的新闻
    GetReadedNews({ commit }, userID) {
      return new Promise((resolve, reject) => {
        getReadedNews(userID).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取相似文章推荐
    GetSimilarArticle({ commit }, newsid) {
      return new Promise((resolve, reject) => {
        getSimilarArticle(newsid).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加相似文章
    AddSimilarArticle({ commit }, params) {
      return new Promise((resolve, reject) => {
        addSimilarArticle(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加相似文章
    DeleteSimilarArticle({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteSimilarArticle(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取行情周报
    GetIndexReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        getIndexReport(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加行情周报
    AddIndexReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        addIndexReport(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改行情周报
    UpdateIndexReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateIndexReport(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除行情周报
    DeleteIndexReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteIndexReport(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取行情指标
    GetPriceIndexList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPriceIndexList(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加或修改行情指标
    AddUpdatePriceIndex({ commit }, params) {
      return new Promise((resolve, reject) => {
        addUpdatePriceIndex(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除行情指标
    DeletePriceIndex({ commit }, indexID) {
      return new Promise((resolve, reject) => {
        deletePriceIndex(indexID).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新闻推送
    PushNews({ commit }, params) {
      return new Promise((resolve, reject) => {
        pushNews(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取评论列表
    GetNewsCommentList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getNewsCommentList(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取被举报评论列表
    GetTipoffCommentList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getTipoffCommentList(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发布、撤销评论
    CommentOperation({ commit }, params) {
      return new Promise((resolve, reject) => {
        commentOperation(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发布、撤销评论
    DeleteNewsComment({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteNewsComment(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户成交价
    GetUserFinalPrice({ commit }, params) {
      return new Promise((resolve, reject) => {
        getUserFinalPrice(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加行情数据
    AddMarketPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        addMarketPriceData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询行情数据
    GetMarketPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getMarketPriceData(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改行情数据
    UpdateMarketPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateMarketPriceData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除行情数据
    DeleteMarketPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteMarketPriceData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 审核用户成交价
    UpdateUserMarketPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateUserMarketPriceData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateCompanyInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyInfo(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBackendIndexReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBackendIndexReport(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    SelectBeefPriceDataIndex({ commit }, params) {
      return new Promise((resolve, reject) => {
        selectBeefPriceDataIndex(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPriceDataResearchs({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPriceDataResearchs(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // getBeefDataEstPatternList
    GetBeefNewImportExportDatasList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefNewImportExportDatasList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetBeefDataEstPatternList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefDataEstPatternList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    DeleteBeefPriceDataIndex({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteBeefPriceDataIndex(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeletePriceDataResearchs({ commit }, params) {
      return new Promise((resolve, reject) => {
        deletePriceDataResearchs(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteBeefNewImportExportDatas({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteBeefNewImportExportDatas(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteBeefDataEstPatterns({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteBeefDataEstPatterns(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateBeefPriceDataIndex({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBeefPriceDataIndex(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateBeefNewImportExportDatas({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBeefNewImportExportDatas(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdatePriceDataResearchs({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePriceDataResearchs(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateBeefDataEstPatterns({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBeefDataEstPatterns(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取期货列表
    GetFuturesMarketData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getFuturesMarketData(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取现货列表
    GetSpotMarketData({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSpotMarketData(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入期货数据
    ImportFuturesMarketData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importFuturesMarketData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入现货数据
    ImportSpotMarketData({ commit }, params) {
      return new Promise((resolve, reject) => {
        importSpotMarketData(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ImportPriceDataIndexs({ commit }, params) {
      return new Promise((resolve, reject) => {
        importPriceDataIndexs(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ImportPriceDataResearchs({ commit }, params) {
      return new Promise((resolve, reject) => {
        importPriceDataResearchs(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ImportBeefNewImportExportDatas({ commit }, params) {
      return new Promise((resolve, reject) => {
        importBeefNewImportExportDatas(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ImportBeefDataEstPatterns({ commit }, params) {
      return new Promise((resolve, reject) => {
        importBeefDataEstPatterns(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetNewsViewUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        getNewsViewUser(params).then(response => {
          commit('SET_ROWS', response.Data.Datas)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default news



// WEBPACK FOOTER //
// ./src/store/modules/news.js